/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

const becomeMfdFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [{
    "@type": "Question",
    name: "Is it necessary to take the NISM exam if I want to register myself with Wealthy?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Yes, according to SEBI regulations, individuals involved in distributing mutual funds are required to possess an AMFI Registration Number (Association of Mutual Funds in India Registration Number). However, you can work with Wealthy in other product categories besides mutual funds without having an ARN. Nevertheless, we highly recommend that you take the exam and obtain your ARN number. In our system, only partners who are certified by AMFI are considered as serious participants with whom we collaborate extensively to grow their business."
    }
  },
  {
    "@type": "Question",
    name: "What is the process of enrollment in Wealthy?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `To enroll in Wealthy.in, follow these steps:
      1.After expressing your interest, you will receive a call from Wealthy’s Relationship Manager to assist you to join NISM training sessions. You will be provided with the required study materials and mock tests
      2.Upon successfully completing the mock tests, Wealthy’s Relationship Manager will assist you in registering for the NISM exam on the NISM website. The exam fee is Rs 1,500 +GST.
      Select a convenient time for the exam and appear for it.
      3.Once you pass the exam, apply for an ARN on the AMFI website. The fee is Rs 1,500 + GST.After obtaining the ARN, attach your ARN with Wealthy by completing your KYC process within the app.
      4.Wealthy’s Relationship Manager will guide you throughout the entire process and remain in touch with you
      `
    }
  },
  {
    "@type": "Question",
    name: "What are the criteria for obtaining an ARN?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `The criteria to obtain an ARN card are as follows:
      Any individual who is at least 18 years old can apply for the NISM - Series V-A Mutual Fund Distribution Examination and on passing the exam apply for an ARN. The fee for an NISM Exam and ARN is Rs 3,000 + GST.
      Private Limited companies, LLPs, and partnership firms can also apply for an ARN card. However, their representative(s) must qualify for the exam. In this case, the fee for an ARN card is Rs 20,000+GST.
      `
    }
  },
  {
    "@type": "Question",
    name: "My age is 55 years. Will I also have to appear in the NISM exam?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "If you are 50 years old and have experience in financial product distribution, you have the option to participate in the Continuing Professional Exam (CPE) training. Upon successfully completing the training, you will become eligible for the ARN. The fee for the CPE training is Rs 2,500 + GST"
    }
  },
  {
    "@type": "Question",
    name: "What is the fee for reappearance in the NISM exam in case I could not pass?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "In case you fail the exam, you simply have to pay Rs 1,500 + GST for a repeat attempt of the NISM Mutual fund VA Exam"
    }
  },
  {
    "@type": "Question",
    name: "Is there any limitation in terms of the number of attempts for appearing in the NISM mutual fund exam?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "There is no limitation on the number of attempts in the exam."
    }
  },
  {
    "@type": "Question",
    name: "What is the validity of ARN? Will I have to reappear for the exam again after the expiry?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "The ARN (Association of Mutual Funds in India Registration Number) has a validity of three years. Once the initial three-year period is completed, it is necessary to undergo the CPE (Continuing Professional Education) training program and renew the ARN for the subsequent three years. This renewal process is required to maintain the validity of the ARN, and it does not involve reappearing in the exam."
    }
  },
  {
    "@type": "Question",
    name: "What is the nearest centre of NISM near my location?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "To find the nearest centre of NISM (National Institute of Securities Markets) near your location, you can visit the official NISM website or contact their customer support."
    }
  },
  {
    "@type": "Question",
    name: "Will I receive a refund for the exam fee if I choose not to work with Wealthy?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Since you pay the exam fee directly to the concerned authority, Wealthy will not be in a position to provide any refund. However, if you achieve a certain target within a given time frame of your joining, your registration fee will be refunded to you. For more information, please contact Wealthy’s Relationship Manager"
    }
  },
  {
    "@type": "Question",
    name: "Will I receive a refund for the exam fee if I choose not to work with Wealthy?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Since you pay the exam fee directly to the concerned authority, Wealthy will not be in a position to provide any refund. However, if you achieve a certain target within a given time frame of your joining, your registration fee will be refunded to you. For more information, please contact Wealthy’s Relationship Manager"
    }
  }
  ]
}
;

export default becomeMfdFaqSchema;
